/* eslint-disable no-shadow,no-param-reassign,no-unused-vars */
import _ from "lodash";
import { isEmpty } from "lodash";
import {
  hasQuestionSkipTo,
  hasPageSkipTo,
  onQuestionShowSummary,
  onQuestionSkipToPage,
  onQuestionSkipToAlternateEnding,
  onNextQuestion,
  onLastQuestionOnPage,
  processComplete,
  calcCompleted,
  getCurrentPage,
  getCurrentQuestion,
  getAnswer,
  onQuestionWithRoutingRules,
  debugProcess,
  questionHasRoutingLogic
} from "./interview.helpers";
// import InterviewsService from "../services/InterviewsService";

const getAllQuestions = state => {
  const questions = [];
  _.forEach(Object.values(state.pages), page => {
    _.forEach(page.attributes.questions, question => {
      questions[question.id] = question;
    });
  });

  return questions;
};

const initialState = {
  id: false,
  createdAt: null,
  publishedAt: null,
  page: 0,
  alternateEnding: "",
  question: 0,
  path: [],
  pages: {},
  alternateEndings: {},
  answers: {},
  onDemandRedirect: null,
  onDemandJwt: null,
  onDemandAutologin: false,
  onDemandSession: null,
  showSummary: false,
  showPrevious: true,
  started: false,
  nextButtonText: "Next Question",
  nextSteps: "",
  nextStepsHeader: "",
  nextStepsButtonLabel: "",
  nextStepsButtonUrl: "",
  startButton: {},
  welcome: {
    header: "",
    message: ""
  },
  userTokenExpiredMessage: "",
  requireUserToken: false,
  next: false,
  edit: false,
  completed: 0,
  preview: false,
  transition: "next",
  referrer: null,
  patient: null,
  patientQueue: {}
};

export const state = initialState;

export const getters = {
  question: state => (page, question) => {
    let q = {};
    if (Object.keys(state.pages).length) {
      const currentPage = _.find(Object.values(state.pages), [
        "attributes.sequence",
        parseInt(page, 10)
      ]);

      q = _.filter(currentPage.attributes.questions, [
        "sequence",
        parseInt(question, 10)
      ])[0];
    }
    return q;
  },
  allQuestions: state => {
    return getAllQuestions(state);
  },
  visuwellUser: state => {
    let found = false;
    let user = {};
    _.forEach(Object.values(state.pages), page => {
      _.forEach(page.attributes.questions, question => {
        if (question.kind === "visuwell_user" && found === false) {
          let maybeUser = getAnswer(state.answers, question)["choice"] || {};
          if (!_.isEmpty(maybeUser)) {
            user = maybeUser;
            found = true;
          }
        }
      });
    });
    return user;
  },
  getAnswer: state => id => state.answers[id],
  showPrevious: state => id => state.showPrevious,
  completed: state => state.completed,
  getAlternateEnding: state => state.alternateEnding,
  getAlternateEndings: state => state.alternateEndings,
  getPage: state => state.page,
  getQuestion: state => state.question,
  showSummary: state => state.showSummary,
  preview: state => state.preview,
  transition: state => state.transition,
  startButton: state => state.startButton,
  welcome: state => state.welcome,
  userTokenExpiredMessage: state => state.userTokenExpiredMessage,
  requireUserToken: state => state.requireUserToken,
  getReferrer: state => state.referrer,
  getPatient: state => state.patient,
  getOnDemandRedirect: state => state.onDemandRedirect,
  getOnDemandJwt: state => state.onDemandJwt,
  getOnDemandAutologin: state => state.onDemandAutologin,
  getOnDemandSession: state => state.onDemandSession,
  started: state => state.started,
  nextButtonText: state => state.nextButtonText
};

export const actions = {
  set({ commit }, payload) {
    commit("set", payload);
  },

  updateQuestion({ commit }, payload) {
    commit("updateQuestion", payload);
  },

  recordAnswer({ commit }, payload) {
    commit("recordAnswer", payload);
  },

  firstQuestion({ commit }) {
    commit("firstQuestion");
  },

  nextQuestion({ commit }) {
    commit("nextQuestion");
  },

  updatePreviousQuestion({ commit }, payload) {
    commit("updatePreviousQuestion", payload);
  },

  editOff({ commit }) {
    commit("editOff");
  },

  start({ commit }) {
    commit("start", true);
  },

  setNext({ commit }, payload) {
    commit("setNext", payload);
  },

  resetAnswers({ commit }) {
    commit("resetAnswers");
  },

  setPage({ commit }, page) {
    commit("setPage", page);
  },

  setPath({ commit }, path) {
    commit("setPath", path);
  },

  setQuestion({ commit }, question) {
    commit("setQuestion", question);
  },

  setOnDemandRedirect({ commit }, payload) {
    commit("setOnDemandRedirect", payload);
  },

  setOnDemandJwt({ commit }, payload) {
    commit("setOnDemandJwt", payload);
  },

  setOnDemandAutologin({ commit }, payload) {
    commit("setOnDemandAutologin", payload);
  },

  setOnDemandSession({ commit }, payload) {
    commit("setOnDemandSession", payload);
  },

  editQuestion({ commit }, payload) {
    commit("editQuestion", payload);
  },

  showSummary({ commit }) {
    commit("showSummary");
  },

  setPreview({ commit }, payload) {
    commit("setPreview", payload);
  },

  setSlideDirection({ commit }, payload) {
    commit("setSlideDirection", payload);
  },
  setReferrer({ commit }, payload) {
    commit("setReferrer", payload);
  },
  setPatient({ commit }, payload) {
    commit("setPatient", payload);
  },

  setPatientQueue({ commit }, payload) {
    commit("setPatientQueue", payload);
  },

  setAnswers({ commit }, payload) {
    commit("setAnswers", payload);
  },

  setExtras({ commit }, payload) {
    commit("setExtras", payload);
  }
};

export const mutations = {
  set(state, data) {
    const interview = Object.values(data.interviews)[0];
    state = Object.assign(
      state,
      {
        id: interview.id,
        createdAt: interview.attributes.createdAt,
        publishedAt: interview.attributes.publishedAt
      },
      { pages: data.interviewPages },
      { alternateEndings: data.interviewAlternateEndings || {} },
      { nextStepsHeader: interview.attributes.nextStepsHeader },
      { nextSteps: interview.attributes.nextSteps },
      { nextStepsButtonLabel: interview.attributes.nextStepsButtonLabel },
      { nextStepsButtonUrl: interview.attributes.nextStepsButtonUrl },
      { nextButtonText: interview.attributes.nextButtonText },
      {
        welcome: {
          header: interview.attributes.welcomeHeader,
          message: interview.attributes.welcomeMessage
        }
      },
      { userTokenExpiredMessage: interview.attributes.userTokenExpiredMessage },
      { requireUserToken: interview.attributes.requireUserToken },
      {
        startButton: {
          text: interview.attributes.startButtonText,
          icon: interview.attributes.startButtonIcon
        }
      }
    );
  },

  updateQuestion(state, question) {
    const pageQuestions =
      state.pages[question.attributes.interviewPageId].attributes.questions;
    const index = _.findIndex(pageQuestions, ["id", question.id]);
    const pages = state.pages;
    pages[question.attributes.interviewPageId].attributes.questions[index] =
      question.attributes;

    state = { ...state, ...pages };
  },

  start(state, started) {
    state = Object.assign(state, { started });
  },

  recordAnswer(state, answer) {
    let started = state.started;
    if (!started) {
      started = true;
    }

    const changed = state.answers[answer.id] !== answer.choice;
    state.answers[answer.id] = answer.choice;

    if (changed && state.edit) {
      const previousPage = state.page;
      const previousQuestion = state.question;
      const questionSkip = hasQuestionSkipTo(
        getCurrentPage(state),
        state.question,
        state.answers
      );

      const currentQuestion = getCurrentQuestion(state);
      const hasRoutingLogic = questionHasRoutingLogic(currentQuestion);

      if (
        hasRoutingLogic === true ||
        (questionSkip && questionSkip !== "summary")
      ) {
        // reset previous path
        let newPath = _.cloneDeep(state.path);
        const pathIndex = _.findIndex(newPath, o => {
          //console.log(o.page, previousPage, o.question, previousQuestion);
          return o.page === previousPage && o.question === previousQuestion;
        });
        newPath = newPath.slice(0, pathIndex + 1);

        // clear answers
        const updatedAnswers = {};
        const sortedPages = _.sortBy(Object.values(state.pages), [
          o => o.attributes.sequence
        ]);
        _.each(newPath, path => {
          const id =
            sortedPages[path.page].attributes.questions[path.question].id;
          updatedAnswers[id] = state.answers[id];
        });

        state = Object.assign(
          state,
          { started },
          { edit: false },
          { path: newPath },
          { answers: updatedAnswers }
        );
      }
    }
  },

  firstQuestion(state) {
    const page = initialState.page;
    const question = initialState.question;
    const showSummary = initialState.showSummary;

    const completed = calcCompleted(page, question, state.pages);

    state = Object.assign(
      state,
      { page },
      { question },
      { showSummary },
      { completed }
    );
  },

  nextQuestion(state) {
    const currentPage = getCurrentPage(state);
    const totalPages = Object.keys(state.pages).length;
    let page = state.page;
    let question = state.question;

    // keep track of the path through the questions for easier 'previous question' button calculations
    const newPath = _.cloneDeep(state.path);
    newPath.push({ page, question });

    let process = {
      decided: false,
      state: state,
      showSummary: state.showSummary,
      page: page,
      question: question,
      questionSkip: hasQuestionSkipTo(currentPage, question, state.answers),
      pageSkip: hasPageSkipTo(currentPage),
      alternateEnding: "",
      currentPage: currentPage,
      currentQuestion: getCurrentQuestion(state),
      totalPages: totalPages,
      onLastPage: page == totalPages - 1,
      completed: 0
    };

    process = _(process)
      .chain()
      .thru(debugProcess)
      .thru(onQuestionWithRoutingRules)
      .thru(debugProcess)
      .thru(onQuestionShowSummary)
      .thru(debugProcess)
      .thru(onQuestionSkipToPage)
      .thru(debugProcess)
      .thru(onQuestionSkipToAlternateEnding)
      .thru(debugProcess)
      .thru(onNextQuestion)
      .thru(debugProcess)
      .thru(onLastQuestionOnPage)
      .thru(debugProcess)
      .thru(processComplete)
      .thru(debugProcess)
      .value();

    state = Object.assign(
      state,
      { showSummary: process.showSummary },
      { page: process.page },
      { alternateEnding: process.alternateEnding },
      { question: process.question },
      { path: newPath },
      { completed: process.completed },
      { transition: "next" }
    );
  },

  updatePreviousQuestion(state, payload) {
    const page = parseInt(payload.page, 10);
    const question = parseInt(payload.question, 10);
    const showSummary = false;
    const next = true;

    const completed = calcCompleted(page, question, state.pages);

    state = Object.assign(
      state,
      { showSummary },
      { page },
      { question },
      { next },
      { completed }
    );
  },

  editOff(state) {
    state = Object.assign(state, { edit: false });
  },

  setNext(state, status) {
    state = Object.assign(state, { next: status });
  },

  resetAnswers(state) {
    state = Object.assign(state, { answers: {} });
  },

  setPage(state, page) {
    state = Object.assign(state, { page: page });
  },

  setPath(state, path) {
    state = Object.assign(state, { path: path });
  },

  setQuestion(state, question) {
    state = Object.assign(state, { question: question });
  },

  setOnDemandRedirect(state, redirect) {
    state = Object.assign(state, { onDemandRedirect: redirect });
  },

  setOnDemandJwt(state, onDemandJwt) {
    state = Object.assign(state, { onDemandJwt: onDemandJwt });
  },

  setOnDemandSession(state, onDemandSession) {
    state = Object.assign(state, { onDemandSession: onDemandSession });
  },

  setOnDemandAutologin(state, onDemandAutologin) {
    state = Object.assign(state, {
      onDemandAutologin: onDemandAutologin
    });
  },

  editQuestion(state, id) {
    let page = state.page;
    let question = state.question;
    const edit = true;
    const next = true;
    const showSummary = false;
    const showPrevious = false;

    _.forEach(Object.values(state.pages), p => {
      const q = _.filter(p.attributes.questions, ["id", id]);
      if (q.length) {
        page = p.attributes.sequence;
        question = q[0].sequence;
      }
    });

    state = Object.assign(
      state,
      { showSummary },
      { showPrevious },
      { page },
      { question },
      { edit },
      { next }
    );
  },

  showSummary(state) {
    state = Object.assign(state, { showSummary: true }, { edit: false });
  },

  setPreview(state, status) {
    state.preview = status;
  },

  setSlideDirection(state, direction) {
    state.transition = direction;
  },
  setReferrer(state, referrer) {
    state.referrer = referrer;
  },
  setPatient(state, patient) {
    state.patient = patient;
  },
  setPatientQueue(state, patientQueue) {
    state = Object.assign(state, { patientQueue: patientQueue });
  },
  setAnswers(state, answers) {
    state = Object.assign(state, { answers: answers });
  },
  setExtras(state, data) {
    state.welcome.header = state.welcome.header.replace(
      "<FIRSTNAME>",
      data.firstName
    );
    _.forEach(Object.values(state.pages), p => {
      _.forEach(p.attributes.questions, q => {
        if (q.dataType === "dt_name") {
          state.answers[q.id] = [
            { choice: "<FIRSTNAME>", value: data.firstName },
            { choice: "<LASTNAME>", value: data.lastName }
          ];
          q.fields[0].value = data.firstName;
          q.fields[1].value = data.lastName;
        }
      });
    });
  }
};
